export default __webpack_public_path__ + "static/media/loader.f500ae01.svg";